
import { faInstagram, faLinkedin, faYoutube, type IconDefinition } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faArrowTrendUp, faChartGantt, faClapperboard, faQuoteRight, faSwatchbook, faVideo, faWaveSquare } from '@fortawesome/free-solid-svg-icons';

export type ContactDetails = {
    email: string,
    cellphone: string,
    whatsapp: string,
    companyLegalName: string,
};

export const CONTACT_DETAILS: ContactDetails = {
    email: 'hello@oursharestudios.com',
    cellphone: '+27689345012',
    whatsapp: 'https://wa.me/27689345012',
    companyLegalName: `© Copyright ${new Date().getFullYear()} Our&nbsp;Share Pty. Ltd.`
}

export type SocialItem = {
    icon: IconDefinition,
    handle: string,
    type: 'external' | 'email',
    href: string,
    scale?: string,
}

export const SOCIAL_LINKS: SocialItem[] = [
    {
        icon: faInstagram,
        handle: '@oursharestudios',
        type: 'external',
        href: 'https://instagram.com/oursharestudios',
        scale: 'scale-[94%]',
    },
    {
        icon: faYoutube,
        handle: '@OurShareStudios',
        type: 'external',
        href: 'https://www.youtube.com/@OurShareStudios',
        scale: 'scale-[108%]',
    },
    {
        icon: faLinkedin,
        handle: 'Our Share Studios',
        type: 'external',
        href: 'https://www.linkedin.com/company/our-share-studios',
        scale: 'scale-[88%]',
    },
    {
        icon: faEnvelope,
        handle: 'hello@oursharestudios.com',
        type: 'email',
        href: 'mailto:hello@oursharestudios.com',
    },
];

export const SERVICE_ITEMS = [
    {
        name: 'Audio Post-Production',
        icon: faWaveSquare,
        imageParams: {
            src: 'https://oursharestudios.imgix.net/stock/audio-mixing-01.jpg',
            width: 500,
            height: 500,
            imgixParams: {
                q: 80,
                fit: 'crop'
            }
        },
        items: [
            'Final Mix',
            'Audio Repair',
            'Sound Design',
            'Voice Over',
        ],
        caption: 'High-fidelty audio, perfect down to the sample.',
    },
    {
        name: 'Video Post-Production',
        icon: faChartGantt,
        imageParams: {
            src: 'https://oursharestudios.imgix.net/stock/color-grading-01.jpg',
            width: 500,
            height: 500,
            imgixParams: {
                q: 80,
                fit: 'crop'
            }
        },
        items: [
            'Editing',
            'Color Grading',
            'Motion Graphics',
        ],
        caption: "Fastest final cut in the West.",
    },
    {
        name: 'Production Services',
        icon: faVideo,
        imageParams: {
            src: 'https://oursharestudios.imgix.net/stock/film-crew-02.jpg',
            width: 500,
            height: 500,
            imgixParams: {
                q: 80,
                fit: 'crop'
            }
        },
        items: [
            'Commercials',
            'Live Broadcast',
            'Videography',
            'Photography',
        ],
        caption: "We're a lean, mean, frame-churning machine.",
    },
    {
        name: 'Studio Services',
        icon: faClapperboard,
        imageParams: {
            src: 'https://oursharestudios.imgix.net/stock/film-director-01.jpg',
            width: 500,
            height: 500,
            imgixParams: {
                q: 80,
                fit: 'crop'
            }
        },
        items: [
            'Podcasts',
            'Photoshoots',
            'Live Streams',
        ],
        caption: "Studio, lab, or theatre — we've got the right space.",
    },
    {
        name: 'Design Services',
        icon: faSwatchbook,
        imageParams: {
            src: 'https://oursharestudios.imgix.net/stock/video-timeline-01.jpg',
            width: 500,
            height: 500,
            imgixParams: {
                q: 80,
                fit: 'crop'
            }
        },
        items: [
            'Graphic Design',
            'Website Development',
        ],
        caption: "From simple doodles, all the way to your entire brand identity.",
    },
    {
        name: 'Marketing Services',
        icon: faArrowTrendUp,
        imageParams: {
            src: 'https://oursharestudios.imgix.net/stock/marketing-01.jpg',
            width: 500,
            height: 500,
            imgixParams: {
                q: 80,
                fit: 'crop'
            }
        },
        items: [
            'Brand Identity',
            'Social Media',
        ],
        caption: "Marketing campaigns like we're a global super-power",
    },
];
